/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommunicationsSocketSubscribeRequest = {
    type: CommunicationsSocketSubscribeRequest.type;
    topics: Array<string>;
    token: string;
};
export namespace CommunicationsSocketSubscribeRequest {
    export enum type {
        SUBSCRIBE_COMMUNICATIONS_V1 = 'subscribe.communications.v1',
    }
}

